"use client";

import {ReactNode, useEffect} from "react";
import {usePathname} from "@/i18n/routing";
import {useParams, useRouter} from "next/navigation";

export default function Refresher({children}: { children: ReactNode }) {
    const pathname = usePathname();
    const {locale} = useParams();
    const router = useRouter();
    useEffect(() => {
        router.refresh();
    }, [pathname, locale]);
    return <>{children}</>;
}